import { render, staticRenderFns } from "./DisinfectionTraining.vue?vue&type=template&id=f1864588&scoped=true&"
import script from "./DisinfectionTraining.vue?vue&type=script&lang=js&"
export * from "./DisinfectionTraining.vue?vue&type=script&lang=js&"
import style0 from "./DisinfectionTraining.vue?vue&type=style&index=0&id=f1864588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1864588",
  null
  
)

export default component.exports